export default __webpack_public_path__ + "static/media/image07.26fcce06.jpg";